import React from "react";

import "./TextToSpeechModal.css";
import { BaseModal } from "../BaseModal";
import { TextToSpeechModalProps, TextToSpeechFormProps } from "./types";
import { TextToSpeechForm } from "./TextToSpeechForm";
import { ModalSize } from "../BaseModal/types";

export const TextToSpeechModal = ({ open, onClose, onFinish, data, isAlternate = false }: TextToSpeechModalProps) => {
  const handleFormSubmit: TextToSpeechFormProps["onSubmit"] = (values) => {
    onFinish(values);
  };
  const handleFormCancel = () => {
    onClose?.();
  };

  return (
    <BaseModal size={ModalSize.LG} open={open} title="Text To Speech">
      <div className="tts-modal-content">
        <TextToSpeechForm
          values={data}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
          isAlternate={isAlternate}
        />
      </div>
    </BaseModal>
  );
};
